'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'eraser';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f12d';
var svgPathData = 'M166.6 464L288 464l25.4 0L383 394.3 181.7 193 38.6 336l128 128zM288 480l-128 0L27.3 347.3 16 336l11.3-11.3L324.7 27.3 336 16l11.3 11.3L548.7 228.7 560 240l-11.3 11.3L336 464l200 0 8 0 0 16-8 0-216 0-32 0zm106.3-97l143-143L336 38.6l-143 143L394.3 383z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEraser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;